/**
 * voteProject接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const voteProject = {
  // 获取投票项目分组集合
  getProjectGroups (params) {
    return axios.get('/api/voteProject/GetProjectGroups', { params })
  },
  getProjectGroup (params) {
    return axios.get('/api/voteProject/GetProjectGroup', { params })
  },
  editProjectGroup (params) {
    return axios.post('/api/voteProject/EditProjectGroup', params)
  },
  deleteProjectGroup (params) {
    return axios.delete('/api/voteProject/DeleteProjectGroup', { params })
  },
  getDefaultProjectGroup (params) {
    return axios.get('/api/voteProject/GetDefaultProjectGroup', { params })
  },
  getProjects (params) {
    return axios.get('/api/voteProject/GetProjects', { params })
  },
  getProject (params) {
    return axios.get('/api/voteProject/GetProject', { params })
  },
  editProject (params) {
    return axios.post('/api/voteProject/EditProject', params)
  },
  editProjectByImages (params) {
    return axios.post('/api/voteProject/EditProjectByImages', params)
  },
  deleteProject (params) {
    return axios.delete('/api/voteProject/DeleteProject', { params })
  },
  exportProjectTemplate (params) {
    return axios({
      method: 'post',
      url: '/api/voteProject/ExportProjectTemplate',
      data: params,
      responseType: 'blob'
    })
  },
  exportCommonProjectTemplate (params) {
    return axios({
      method: 'post',
      url: '/api/voteProject/ExportCommonProjectTemplate',
      data: params,
      responseType: 'blob'
    })
  },
  getProjectSelectList (params) {
    return axios.get('/api/voteProject/GetProjectSelectList', { params })
  }
}

export default voteProject
